import React, {useEffect, useState} from 'react';
import WebFont from "webfontloader";

export default (fontList) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    useEffect( () => {
        // Load the fonts at first go:
        WebFont.load({
            // All fonts successfully loaded:
            active: () => {
                setLoaded(true)
            },
            google: {
                families: fontList
            }
        });
    }, []);

    return {loaded, error};
}